"use client";

import Image from "next/image";
import Link from "next/link";
import clsx from "clsx";
import { useState } from "react";
import { avenirNextDemi, fontAwesome } from "@/styles/fonts";

type CornerCaseNavbarProps = {
    variant: "logo-only" | "links-only";
    positionClass?: "absolute" | "relative";
};

const menuItemClass = clsx(
    "relative",
    "block",
    "p-[13px]",
    "leading-[20px]",
    "text-white",
    "opacity-60",
    "hover:opacity-100",
);

export default function CornerCaseNavbar({
    variant,
    positionClass = "absolute",
}: CornerCaseNavbarProps) {
    const [isMenuOpen, setMenuOpen] = useState(false);

    const menuItems = (
        <>
            <li className={menuItemClass}>
                <Link href="/tour" onClick={() => setMenuOpen(false)}>Features</Link>
            </li>
            <li className={menuItemClass}>
                <Link href="/about_us" onClick={() => setMenuOpen(false)}>About Us</Link>
            </li>
            <li className={menuItemClass}>
                <Link href="/our_data" onClick={() => setMenuOpen(false)}>Our Data</Link>
            </li>
            <li className={menuItemClass}>
                <Link href="/pricing" onClick={() => setMenuOpen(false)}>Pricing</Link>
            </li>
        </>
    );

    return (
        <nav className={clsx(
            "z-40",
            "w-full",
            "min-h-[50px]",
            "mb-[10px]",
            "leading-[1.15]",
            "pb-[8px]",
            "sm:pb-[28px]",
            "md:pb-[35px]",
            "lg:pb-0",
            "pt-[10px]",
            "lg:pt-[40px]",
            positionClass,
        )}>
            <div className={clsx(
                "mx-auto w-full max-w-[1650px]",
                variant === "links-only" ? "sm:hidden" : "block",
            )}>
                <div className={clsx(
                    "flex",
                    "items-center",
                    "justify-between",
                    "gap-[10px]",
                    "px-[2%]",
                    "md:px-[3%]",
                    "lg:px-[5%]",
                    "xl:px-[10%]",
                )}>
                    <Link href="/" className="h-[50px] py-[11px] pr-[15px] lg:py-[7px]">
                        <Image
                            src="/public/images/adbeat-logo.svg"
                            width={90}
                            height={22}
                            alt="Adbeat logo"
                        />
                    </Link>

                    {variant === "links-only" && (
                        <button
                            onClick={() => setMenuOpen(!isMenuOpen)}
                            aria-expanded={isMenuOpen}
                            aria-label="Toggle menu"
                            className={clsx(
                                "border-[#ddd] py-[9px] px-[10px] my-[8px] mr-[4px] border-[1px] rounded text-[14px] transition-colors",
                                isMenuOpen ? "bg-[#ddd] text-[#4d5760]" : "bg-transparent text-[#86939e]",
                            )}
                            type="button"
                        >
                            Menu <span className={fontAwesome.className}>&#xf0c9;</span>
                        </button>
                    )}
                </div>

                {variant === "links-only" && (
                    <div
                        className={clsx(
                            avenirNextDemi.className,
                            "mx-[2%]",
                            "px-[15px]",
                            "rounded-b",
                            "bg-[#13172c]",
                        )}
                        style={{
                            transition: "all 0.3s ease-in-out",
                            maxHeight: isMenuOpen ? "500px" : "0px",
                            overflow: "hidden",
                            paddingBottom: isMenuOpen ? "10px" : "0px",
                        }}
                    >
                        <ul className="w-full">
                            {menuItems}
                        </ul>
                    </div>
                )}
            </div>

            <div className={clsx(
                "mx-auto w-full max-w-[1650px]",
                variant === "links-only" ? "hidden sm:block" : "hidden",
            )}>
                <div className={clsx(
                    "flex",
                    "items-center",
                    "justify-between",
                    "gap-[10px]",
                    "px-[2%]",
                    "md:px-[3%]",
                    "lg:px-[5%]",
                    "xl:px-[10%]",
                )}>
                    <Link href="/" className="h-[50px] py-[11px] pr-[15px] lg:py-[7px]">
                        <Image
                            src="/public/images/adbeat-logo.svg"
                            width={90}
                            height={22}
                            alt="Adbeat logo"
                        />
                    </Link>

                    <ul className={clsx(
                        avenirNextDemi.className,
                        "flex",
                        "items-center",
                        "justify-end",
                        "flex-wrap",
                        "gap-x-[4px]",
                        "gap-y-[0px]",
                        "text-[16px]",
                        "lg:max-lg:text-[14px]",
                    )}>
                        {menuItems}
                    </ul>
                </div>
            </div>
        </nav>
    );
}
